// Browser/Vite version: safe to use import.meta.env
function getApiBase() {
  // 1. Explicit env var set at build time always wins
  // eslint-disable-next-line no-undef
  const envUrl = (typeof import.meta !== 'undefined' && import.meta.env)
    // eslint-disable-next-line no-undef
    ? import.meta.env.VITE_API_BASE_URL
    : undefined;
  if (envUrl && envUrl !== '/api') return envUrl;

  // 2. Runtime hostname detection — works even when VITE_API_BASE_URL is not set
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    const prodHosts = ['movd.ca', 'www.movd.ca', 'movd-client.onrender.com', 'movd-1.onrender.com'];
    if (prodHosts.some(h => host === h || host.endsWith('.' + h))) {
      return 'https://movd-1.onrender.com/api';
    }
  }

  // 3. Local dev — Vite proxy handles /api → localhost:3004
  return '/api';
}

function getBackendOrigin() {
  const apiBase = getApiBase();

  if (apiBase.startsWith('http')) {
    return apiBase.replace(/\/api\/?$/, '');
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname.toLowerCase();
    const isProd = ['movd.ca', 'www.movd.ca', 'movd-client.onrender.com', 'movd-1.onrender.com'].some(h => hostname === h || hostname.endsWith('.' + h));
    if (isProd) {
      return 'https://movd-1.onrender.com';
    }
  }

  return 'http://localhost:3004';
}

export { getApiBase, getBackendOrigin };
